module.exports = __webpack_public_path__ + "assets/overlayauto.1743b76c.svg";